import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';

import { useAccountStore } from '~stores/account';

export default function useNavLinks() {
  const accountStore = useAccountStore();
  const { account, accessPartnerNewPage } = storeToRefs(accountStore);
  const { locale } = useI18n();

  const navLinks = computed(() => ({
    support: { href: 'mailto:support@transfer-now.ru' },
    faq: 'faq',
  }));

  const legalPages = computed(() => ['terms_of_use']);

  function navLinkWithLocale(navLink) {
    return `/${locale.value}/${navLink}`;
  }

  return {
    navLinks,
    legalPages,
    navLinkWithLocale,
  };
}
